import type { RelativeAbsolutePosition } from '../../types/pointer-events.ts';

export type CurrentRange = [number, number];
export type NextRange = [
  Pick<RelativeAbsolutePosition, 'relative'>,
  Pick<RelativeAbsolutePosition, 'relative'>,
];

export const LEFT_EDGE_ID = 'left-edge';
export const RIGHT_EDGE_ID = 'right-edge';

const changedStart = (
  [currentStart, currentEnd]: CurrentRange,
  [nextStart, nextEnd]: NextRange,
) => {
  return (
    nextStart.relative.x !== currentStart && nextEnd.relative.x === currentEnd
  );
};

const changedEnd = (
  [currentStart, currentEnd]: CurrentRange,
  [nextStart, nextEnd]: NextRange,
) => {
  return (
    nextStart.relative.x === currentStart && nextEnd.relative.x !== currentEnd
  );
};

export const changedEdge = (
  currentRange: CurrentRange,
  nextRange: NextRange,
) => {
  if (changedStart(currentRange, nextRange)) {
    return LEFT_EDGE_ID;
  }

  if (changedEnd(currentRange, nextRange)) {
    return RIGHT_EDGE_ID;
  }
  return false;
};
